export const APP_VERSION = "11.1.4-rc.815";
